module.exports = __webpack_public_path__ + "static/media/hero-background.8fe87113.png";